<script lang="ts" setup>
import { useSharedState } from 'composables/useSharedState';
import { AccordionProps } from './AccordionProps';

const props = withDefaults(defineProps<AccordionProps>(), {
  openItems: () => [],
  multiple: false
});

useSharedState<AccordionProps>(props);
</script>

<template>
  <div class="e-accordion-root">
    <slot />
  </div>
</template>
